var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "staff-management-settings-container" },
    [
      _c("div", { staticClass: "global-rate-of-pay-table" }, [
        _c("div", { staticClass: "table-header" }, [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-md-12" },
              [
                _c("HeaderColumn", {
                  staticClass: "col-mileage-rate",
                  attrs: {
                    headerObject: _vm.arrHeaderObj[0],
                    sortObject: _vm.sortObject
                  },
                  on: { CHANGE_SORT_OPTION: _vm.handleChangeSortOption }
                })
              ],
              1
            )
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "list-staff-settings" }, [
          _c("div", { staticClass: "ems-row" }, [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-10" }, [
                _vm.editting
                  ? _c("div", { staticClass: "input-currency field-value" }, [
                      _vm.staffSettingCurrency.type === "checkbox"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: "checkbox" },
                                domProps: {
                                  checked: Array.isArray(
                                    _vm.staffSettings.value
                                  )
                                    ? _vm._i(_vm.staffSettings.value, null) > -1
                                    : _vm.staffSettings.value
                                },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  change: function($event) {
                                    var $$a = _vm.staffSettings.value,
                                      $$el = $event.target,
                                      $$c = $$el.checked ? true : false
                                    if (Array.isArray($$a)) {
                                      var $$v = null,
                                        $$i = _vm._i($$a, $$v)
                                      if ($$el.checked) {
                                        $$i < 0 &&
                                          _vm.$set(
                                            _vm.staffSettings,
                                            "value",
                                            $$a.concat([$$v])
                                          )
                                      } else {
                                        $$i > -1 &&
                                          _vm.$set(
                                            _vm.staffSettings,
                                            "value",
                                            $$a
                                              .slice(0, $$i)
                                              .concat($$a.slice($$i + 1))
                                          )
                                      }
                                    } else {
                                      _vm.$set(_vm.staffSettings, "value", $$c)
                                    }
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                        : _vm.staffSettingCurrency.type === "radio"
                        ? _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: "radio" },
                                domProps: {
                                  checked: _vm._q(_vm.staffSettings.value, null)
                                },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  change: function($event) {
                                    _vm.$set(_vm.staffSettings, "value", null)
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                        : _c(
                            "input",
                            _vm._b(
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.staffSettings.value,
                                    expression: "staffSettings.value"
                                  }
                                ],
                                staticClass: "value-text",
                                attrs: { type: _vm.staffSettingCurrency.type },
                                domProps: { value: _vm.staffSettings.value },
                                on: {
                                  blur: _vm.handleBlurInputValue,
                                  input: function($event) {
                                    if ($event.target.composing) {
                                      return
                                    }
                                    _vm.$set(
                                      _vm.staffSettings,
                                      "value",
                                      $event.target.value
                                    )
                                  }
                                }
                              },
                              "input",
                              _vm.staffSettingCurrency,
                              false
                            )
                          )
                    ])
                  : _c(
                      "div",
                      {
                        staticClass: "mileage-rate-value field-value value-text"
                      },
                      [
                        _vm._v(
                          _vm._s(
                            _vm._f("staffSettingCurrency")(
                              _vm.staffSettings.value || 0
                            )
                          )
                        )
                      ]
                    )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-md-2" }, [
                _c("div", { staticClass: "group-action-btn" }, [
                  _c(
                    "button",
                    {
                      staticClass: "ap-btn edit-btn",
                      on: { click: _vm.handleEditSettingClick }
                    },
                    [_c("div", { staticClass: "icon" })]
                  ),
                  _vm._v(" "),
                  _vm._m(0)
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "editMileageRateModal",
          staticClass: "ap-modal edit-mileage-rate-modal",
          attrs: {
            id: "editMileageRateModal",
            "hide-header": "",
            "hide-footer": ""
          }
        },
        [
          _c("div", { staticClass: "modal-mileage-rate-wrapper" }, [
            _c("div", { staticClass: "h2-text" }, [
              _vm._v("Edit Mileage Rate")
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "ap-field-input-wrapper" }, [
              _c("div", { staticClass: "body-text" }, [_vm._v("Mileage Rate")]),
              _vm._v(" "),
              _c("div", { staticClass: "ap-input-wrapper" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.staffSettings.value,
                      expression: "staffSettings.value"
                    }
                  ],
                  staticClass: "input",
                  attrs: { type: "number" },
                  domProps: { value: _vm.staffSettings.value },
                  on: {
                    input: function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(_vm.staffSettings, "value", $event.target.value)
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "group-btn margin-top-24px" }, [
                _c(
                  "button",
                  {
                    staticClass: "ap-btn secondary cancel-btn",
                    on: { click: _vm.handleCancelClick }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "ap-btn primary save-btn",
                    on: { click: _vm.handleSaveClick }
                  },
                  [_vm._v("Save")]
                )
              ])
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "ap-btn delete-btn" }, [
      _c("div", { staticClass: "icon" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5b81a1ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b81a1ef","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/globalSettings/GlobalRateOfPay.vue
// module id = 2066
// module chunks = 1